/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/img-redundant-alt */
import { useState, useEffect } from "react";
import { get } from "lodash";
import { FormHelperText, Switch } from "@mui/material";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import cogoToast from 'cogo-toast';
import { Form, InputGroup, Button, Modal } from "react-bootstrap"
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { formatStatus, formatUsername, formatDate } from "../../../../util/Helpers";
import * as handlers from "../../_redux/settings/settingsHandlers";
import Webhook from "./webhook";
import {
  useGetCronsHealthReportQuery,
  useGetWebsiteHealthQuery,
  useSetMarketStatusMutation,
  useTriggerPendingBvnMutation
} from "../../../../../redux/apiSlice";
import DynamicSimpleTable from "../../../../util/DynamicSimpleReactTable";

const localStorageActiveTabKey = "settingsTab";

const Settings = _ => {
  const dispatch = useDispatch();
  const notification = useSelector(({ settings }) => settings.notification, shallowEqual);
  const activeTab = localStorage.getItem(localStorageActiveTabKey);
  const [key, setKey] = useState(activeTab ? +activeTab : 0);
  const [showPassword, setShowPassword] = useState(false);
  const [isTriggeringBvn, setIsTriggeringBvn] = useState(false);
  const [showConfirmBvn, setShowConfirmBvn] = useState(false);
  const [selectedCron, setSelectedCron] = useState(null);


  const saveCurrentTab = (_tab) => {
    localStorage.setItem(localStorageActiveTabKey, _tab);
  };
  let handleBlur, handleChange, values;

  const [
    setMarketStatus, // This is the mutation trigger

  ] = useSetMarketStatusMutation()

  const [triggerPendingBvn] = useTriggerPendingBvnMutation();
  const { data: cronsHealthResponse, isFetching: isFetchingCronsHealth } = useGetCronsHealthReportQuery();
  const {
    data: websiteHealthResponse,
    isFetching: isFetchingWebsiteHealth,
    refetch: refetchWebsiteHealth
  } = useGetWebsiteHealthQuery();
  const cronsHealth = Array.isArray(cronsHealthResponse?.crons)
    ? cronsHealthResponse.crons
    : Array.isArray(cronsHealthResponse?.data?.crons)
      ? cronsHealthResponse.data.crons
      : [];
  const cronsCheckedAt = cronsHealthResponse?.checkedAt || cronsHealthResponse?.data?.checkedAt;
  const activeCrons = cronsHealth.filter((cron) => cron?.status?.toLowerCase() === "active").length;
  const downCrons = cronsHealth.filter((cron) => cron?.runtimeStatus?.toUpperCase() === "DOWN").length;
  const websiteHealth = (
    websiteHealthResponse?.data && typeof websiteHealthResponse.data === "object"
      ? websiteHealthResponse.data
      : websiteHealthResponse
  ) || {};
  const rawWebsiteStatusCode =
    websiteHealth?.statusCode ??
    websiteHealth?.httpCode ??
    websiteHealth?.code ??
    websiteHealth?.status_code;
  const websiteStatusCode = Number.isFinite(Number(rawWebsiteStatusCode))
    ? Number(rawWebsiteStatusCode)
    : null;
  const websiteCheckedAt = websiteHealth?.checkedAt || websiteHealth?.updatedAt || websiteHealth?.createdAt;
  const websiteTarget = websiteHealth?.target || websiteHealth?.url || "https://www.trovefinance.com";
  const normalizedWebsiteStatus = `${websiteHealth?.status || websiteHealth?.state || websiteHealth?.verdict || ""}`.toUpperCase();
  const websiteReason =
    websiteHealth?.reason ||
    websiteHealth?.message ||
    websiteHealth?.error ||
    (websiteStatusCode === 200 ? "Website is responding normally." : "No failure reason provided.");
  const websiteResponseTime = websiteHealth?.responseTimeMs ?? websiteHealth?.latencyMs ?? websiteHealth?.responseTime;
  const explicitWebsiteLive =
    typeof websiteHealth?.isLive === "boolean"
      ? websiteHealth.isLive
      : typeof websiteHealth?.live === "boolean"
        ? websiteHealth.live
        : typeof websiteHealth?.up === "boolean"
          ? websiteHealth.up
          : null;
  const websiteIsLive =
    explicitWebsiteLive !== null
      ? explicitWebsiteLive
      : normalizedWebsiteStatus
        ? ["LIVE", "UP", "OK", "HEALTHY", "SUCCESS"].includes(normalizedWebsiteStatus)
        : websiteStatusCode === 200;
  const websiteHealthLabel = websiteIsLive ? "LIVE" : "DOWN";
  const websiteHealthColor = websiteIsLive ? "success" : "danger";
  const renderCronRuntimeStatus = (status) => {
    const normalizedStatus = status?.toUpperCase();
    const color = normalizedStatus === "UP" ? "success" : normalizedStatus === "DOWN" ? "danger" : "warning";
    return (
      <span className={`label label-lg label-light-${color} label-inline`}>
        {normalizedStatus || "UNKNOWN"}
      </span>
    );
  };
  const formatCronDrift = (cron) => {
    const drift = Number(cron?.driftInSeconds);
    if (!Number.isFinite(drift) || drift > 999999999) {
      return "N/A";
    }
    return `${drift}s / ${cron?.allowedDriftSeconds ?? "-"}s`;
  };
  const openCronModal = (cron) => setSelectedCron(cron);
  const closeCronModal = () => setSelectedCron(null);

  const onSubmit = () => {
    const values = { market, status, nextClose };
    setMarketStatus(values)
      .unwrap()
      .then(() => {
        cogoToast.success("Created 'Set Market Status' Action Successfully");
      })

  };

  const [market, setMarket] = useState("ngx");
  const [status, setStatus] = useState("open");
  const [nextClose, setNextClose] = useState("");
  const [nextOpen, setNextOpen] = useState("");

  const onTriggerPendingBvn = () => setShowConfirmBvn(true);

  const onConfirmTriggerPendingBvn = async () => {
    try {
      setIsTriggeringBvn(true);
      await triggerPendingBvn().unwrap();
      cogoToast.success("Reprocess Pending BVN Action Successful");
      setShowConfirmBvn(false);
    } catch (e) {
      // error handled globally via axiosBaseQuery toast
    } finally {
      setIsTriggeringBvn(false);
    }
  };


  /* Notification Pop up */
  useEffect(() => {
    if (notification) {
      cogoToast[notification.type](notification.message);
      dispatch(handlers.clearNotification());
    }
  });

  return (
    <>
      <div className="card card-custom">
        {/*Header*/}
        <div className="card-header card-header-tabs-line">
          <ul
            className="nav nav-dark nav-bold nav-tabs nav-tabs-line"
            data-remember-tab="tab_id"
            role="tablist"
          >
            <li className="nav-item">
              <a
                className={`nav-link ${key === 0 ? "active" : ""}`}
                data-toggle="tab"
                onClick={() => {
                  setKey(0);
                  saveCurrentTab(0);
                }}
              >
                Api Key
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${key === 1 ? "active" : ""}`}
                data-toggle="tab"
                onClick={() => {
                  setKey(1);
                  saveCurrentTab(1);
                }}
              >
                Webhook
              </a>
            </li>
            <li className="nav-item d-none">
              <a
                className={`nav-link ${key === 2 ? "active" : ""}`}
                data-toggle="tab"
                onClick={() => {
                  setKey(2);
                  saveCurrentTab(2);
                }}
              >
                Content
              </a>
            </li>
            <li className="nav-item d-none">
              <a
                className={`nav-link ${key === 3 ? "active" : ""}`}
                data-toggle="tab"
                onClick={() => {
                  setKey(3);
                  saveCurrentTab(3);
                }}
              >
                Aside
              </a>
            </li>
            <li className="nav-item d-none">
              <a
                className={`nav-link ${key === 4 ? "active" : ""}`}
                data-toggle="tab"
                onClick={() => {
                  setKey(4);
                  saveCurrentTab(4);
                }}
              >
                Footer
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${key === 5 ? "active" : ""}`}
                data-toggle="tab"
                onClick={() => {
                  setKey(5);
                  saveCurrentTab(5);
                }}
              >
                Market Status
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${key === 6 ? "active" : ""}`}
                data-toggle="tab"
                onClick={() => {
                  setKey(6);
                  saveCurrentTab(6);
                }}
              >
               Pending BVN Verification 
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${key === 7 ? "active" : ""}`}
                data-toggle="tab"
                onClick={() => {
                  setKey(7);
                  saveCurrentTab(7);
                }}
              >
                Cron Health
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${key === 8 ? "active" : ""}`}
                data-toggle="tab"
                onClick={() => {
                  setKey(8);
                  saveCurrentTab(8);
                }}
              >
                Website Health
              </a>
            </li>
          </ul>
        </div>

        <div className="form">
          <div className="card-body pt-0">
            <div className="tab-content">
              <div className={`tab-pane pt-10 ${key === 0 ? "active" : ""}`}>
                <div className="form-group row">
                  <label className="col-lg-3 col-form-label text-lg-right">
                    Host:
                  </label>
                  <div className="col-lg-9 col-xl-4">
                    <Form.Control
                      type="url"
                      defaultValue="https://bo-api.trovefinance.io"
                      readOnly
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-lg-3 col-form-label text-lg-right">
                    Group Id:
                  </label>
                  <div className="col-lg-9 col-xl-4">
                    <Form.Control type="text" defaultValue="trove" readOnly />
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-lg-3 col-form-label text-lg-right">
                    Username:
                  </label>
                  <div className="col-lg-9 col-xl-4">
                    <Form.Control type="text" defaultValue="praise" readOnly />
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-lg-3 col-form-label text-lg-right">
                    Password:
                  </label>
                  <InputGroup className="col-lg-9 col-xl-4">
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      defaultValue="praisevhbjbhb"
                      readOnly
                    />
                    <InputGroup.Append>
                      <Button
                        variant="outline-secondary"
                        onClick={(_) => setShowPassword(!showPassword)}
                      >
                        <SVG
                          src={
                            showPassword
                              ? toAbsoluteUrl("/media/svg/icons/General/Eye-2.svg")
                              : toAbsoluteUrl("/media/svg/icons/General/Eye-1.svg")
                          }
                        />
                      </Button>
                    </InputGroup.Append>
                  </InputGroup>
                </div>
              </div>
              {key === 1 && <Webhook />}
              <div className={`tab-pane pt-10 ${key === 2 ? "active" : ""}`}>
                <div className="form-group row">
                  <label className="col-lg-3 col-form-label text-lg-right">
                    Width:
                  </label>
                  <div className="col-lg-9 col-xl-4">
                    <select
                      className="form-control"
                      name="content.width"
                      onBlur={handleBlur}
                      value={get(values, "content.width")}
                      onChange={handleChange}
                    >
                      <option value="fluid">Fluid</option>
                      <option value="fixed">Fixed</option>
                    </select>
                    <FormHelperText>Select layout width type</FormHelperText>
                  </div>
                </div>
              </div>
              <div className={`tab-pane pt-10 ${key === 3 ? "active" : ""}`}>
                <div className="form-group row">
                  <label className="col-lg-3 col-form-label text-lg-right">
                    Display Secondary Panel:
                  </label>
                  <div className="col-lg-9 col-xl-4">
                    <Switch
                      onBlur={handleBlur}
                      onChange={handleChange}
                      name="aside.secondary.display"
                      checked={!!get(values, "aside.secondary.display")}
                    />
                    <FormHelperText>Display aside secondary panel</FormHelperText>
                  </div>
                </div>

                <div className="form-group row">
                  <label className="col-lg-3 col-form-label pt-4 text-lg-right">
                    Aside Minimize:
                  </label>
                  <div className="col-lg-9 col-xl-4">
                    <Switch
                      onBlur={handleBlur}
                      onChange={handleChange}
                      name="aside.self.minimize.toggle"
                      checked={!!get(values, "aside.self.minimize.toggle")}
                    />
                    <FormHelperText>Allow aside minimizing</FormHelperText>
                  </div>
                </div>

                <div className="form-group row">
                  <label className="col-lg-3 col-form-label pt-4 text-lg-right">
                    Aside Default Minimized:
                  </label>
                  <div className="col-lg-9 col-xl-4">
                    <Switch
                      onBlur={handleBlur}
                      onChange={handleChange}
                      name="aside.self.minimize.default"
                      checked={!!get(values, "aside.self.minimize.default")}
                    />
                    <FormHelperText>Set aside minimized by default</FormHelperText>
                  </div>
                </div>
              </div>
              <div className={`tab-pane pt-10 ${key === 4 ? "active" : ""}`}>
                <div className="form-group row">
                  <label className="col-lg-3 col-form-label pt-4 text-lg-right">
                    Fixed Footer:
                  </label>
                  <div className="col-lg-9 col-xl-4">
                    <Switch
                      onBlur={handleBlur}
                      onChange={handleChange}
                      name="footer.fixed"
                      checked={!!get(values, "footer.fixed")}
                    />
                    <FormHelperText>
                      Set fixed footer for desktop mode only
                    </FormHelperText>
                  </div>
                </div>

                <div className="form-group row">
                  <label className="col-lg-3 col-form-label text-lg-right">
                    Width:
                  </label>
                  <div className="col-lg-9 col-xl-4">
                    <select
                      className="form-control form-control-solid"
                      name="footer.width"
                      onBlur={handleBlur}
                      value={get(values, "footer.width")}
                      onChange={handleChange}
                    >
                      <option value="fluid">Fluid</option>
                      <option value="fixed">Fixed</option>
                    </select>
                    <FormHelperText>Select layout width type</FormHelperText>
                  </div>
                </div>
              </div>
              <div className={`tab-pane pt-10 ${key === 5 ? "active" : ""}`}>
                <div className="form-group row">
                  <label className="col-lg-3 col-form-label text-lg-right">
                    Market:
                  </label>
                  <div className="col-lg-9 col-xl-4">
                    <select
                      className="form-control"
                      name="market"
                      value={market}
                      onChange={(e) => setMarket(e.target.value)}
                    >
                      <option value="ngx">Nigeria</option>
                      <option value="dw">Foreign</option>
                    </select>
                  </div>

                </div>
                <div className="form-group row">
                  <label className="col-lg-3 col-form-label text-lg-right">
                    Status:
                  </label>
                  <div className="col-lg-9 col-xl-4">

                    <select
                      className="form-control"
                      name="status"
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <option value="open">Open</option>
                      <option value="close">Close</option>
                    </select>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-lg-3 col-form-label text-lg-right">
                    Next Close:
                  </label>
                  <div className="col-lg-9 col-xl-4">
                    <input
                      type="date"
                      className="form-control"
                      name="nextClose"
                      value={nextClose}
                      onChange={(e) => setNextClose(e.target.value)}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-lg-3 col-form-label text-lg-right">
                    Next Open:
                  </label>
                  <div className="col-lg-9 col-xl-4">
                    <input
                      type="date"
                      className="form-control"
                      name="nextOpen"
                      value={nextOpen}
                      onChange={(e) => setNextOpen(e.target.value)}
                    />
                  </div>
                </div>

                <div className="form-group row">
                  <div className="col-lg-9 col-xl-4 offset-lg-3 d-flex justify-content-end">
                    <Button variant="primary" onClick={onSubmit}>Done</Button>
                  </div>
                </div>
              </div>


              <div className={`tab-pane pt-10 ${key === 6 ? "active" : ""}`}>
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h5 className="mb-0">Pending BVN Verification</h5>
                  <button
                    className="btn btn-success font-weight-bold"
                    style={{ backgroundColor: '#28a745', borderColor: '#28a745' }}
                    disabled={isTriggeringBvn}
                    onClick={onTriggerPendingBvn}
                  >
                    {isTriggeringBvn ? "Processing..." : "Reprocess Pending BVN verifications "}
                  </button>

                </div>

                <DynamicSimpleTable
                  source={{ url: `/settings/pending-bvns` }}
                  columns={[
                    {
                      title: 'Name',
                      format: (row) => formatUsername(row.userId, row.username || 'N/A')
                    },
                    { key: 'userId', title: 'User ID' },
                    { key: 'updated', title: 'Created', format: (row) => new Date(row.updated).toLocaleDateString() },
                
                  ]}
                  searchBox={true}
                  refreshIcon={true}


                />
              </div>

              <div className={`tab-pane pt-10 ${key === 7 ? "active" : ""}`}>
                <div className="d-flex justify-content-between align-items-center mb-6">
                  <div>
                    <h5 className="mb-1">Cron Health Report</h5>
                    <div className="text-muted font-size-sm">
                      Monitor active cron jobs, runtime status, drift, and next execution windows.
                    </div>
                  </div>
                  <div className="text-muted font-size-sm">
                    Last checked: {cronsCheckedAt ? formatDate(cronsCheckedAt) : "-"}
                  </div>
                </div>

                <div className="row mb-4">
                  <div className="col-md-4 mb-4">
                    <div className="card card-custom bg-light-primary border-0 shadow-none h-100 mb-0">
                      <div className="card-body py-5">
                        <div className="text-muted text-uppercase font-size-sm font-weight-bold mb-2">Total Crons</div>
                        <div className="font-size-h2 font-weight-bolder text-dark">
                          {isFetchingCronsHealth ? "..." : (cronsHealthResponse?.count ?? cronsHealth.length)}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 mb-4">
                    <div className="card card-custom bg-light-success border-0 shadow-none h-100 mb-0">
                      <div className="card-body py-5">
                        <div className="text-muted text-uppercase font-size-sm font-weight-bold mb-2">Active</div>
                        <div className="font-size-h2 font-weight-bolder text-dark">
                          {isFetchingCronsHealth ? "..." : activeCrons}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 mb-4">
                    <div className="card card-custom bg-light-danger border-0 shadow-none h-100 mb-0">
                      <div className="card-body py-5">
                        <div className="text-muted text-uppercase font-size-sm font-weight-bold mb-2">Runtime Down</div>
                        <div className="font-size-h2 font-weight-bolder text-dark">
                          {isFetchingCronsHealth ? "..." : downCrons}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="table table-head-custom table-head-bg table-borderless table-vertical-center">
                    <thead>
                      <tr className="text-left text-uppercase">
                        <th>Name</th>
                        <th>Runtime</th>
                        <th>Status</th>
                        <th>Last Run</th>
                        <th>Next Run</th>
                        <th>Drift</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {isFetchingCronsHealth && (
                        <tr>
                          <td colSpan="7" className="text-muted">Loading cron health report...</td>
                        </tr>
                      )}
                      {!isFetchingCronsHealth && cronsHealth.length === 0 && (
                        <tr>
                          <td colSpan="7" className="text-muted">No cron health data available.</td>
                        </tr>
                      )}
                      {cronsHealth.map((cron) => (
                        <tr key={cron.id || cron.address || cron.name}>
                          <td>
                            <div className="font-weight-bolder text-dark">{cron.name || cron.address || "-"}</div>
                            <div className="text-muted font-size-sm">{cron.description || cron.schedule || "-"}</div>
                          </td>
                          <td>{renderCronRuntimeStatus(cron.runtimeStatus)}</td>
                          <td>{formatStatus(cron.status || "unknown")}</td>
                          <td>{cron.lastRunTime ? formatDate(cron.lastRunTime) : <span className="text-muted">Never</span>}</td>
                          <td>{cron.nextRunTime ? formatDate(cron.nextRunTime) : <span className="text-muted">-</span>}</td>
                          <td>{formatCronDrift(cron)}</td>
                          <td className="text-right">
                            <button
                              type="button"
                              className="btn btn-icon btn-light btn-hover-primary btn-sm bg-white"
                              title="View"
                              onClick={() => openCronModal(cron)}
                            >
                              <i className="fa fa-eye" />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className={`tab-pane pt-10 ${key === 8 ? "active" : ""}`}>
                <div className="d-flex justify-content-between align-items-center mb-6">
                  <div>
                    <h5 className="mb-1">Website Health</h5>
                    <div className="text-muted font-size-sm">
                      Monitor the public website status from the backend health-check endpoint.
                    </div>
                  </div>
                  <Button
                    variant="light-primary"
                    className="font-weight-bold"
                    onClick={() => refetchWebsiteHealth()}
                    disabled={isFetchingWebsiteHealth}
                  >
                    {isFetchingWebsiteHealth ? "Refreshing..." : "Refresh"}
                  </Button>
                </div>

                <div className="row mb-4">
                  <div className="col-md-3 mb-4">
                    <div className={`card card-custom bg-light-${websiteHealthColor} border-0 shadow-none h-100 mb-0`}>
                      <div className="card-body py-5">
                        <div className="text-muted text-uppercase font-size-sm font-weight-bold mb-2">Status</div>
                        <div className="font-size-h2 font-weight-bolder text-dark">{isFetchingWebsiteHealth ? "..." : websiteHealthLabel}</div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 mb-4">
                    <div className="card card-custom bg-light-primary border-0 shadow-none h-100 mb-0">
                      <div className="card-body py-5">
                        <div className="text-muted text-uppercase font-size-sm font-weight-bold mb-2">HTTP Code</div>
                        <div className="font-size-h2 font-weight-bolder text-dark">{isFetchingWebsiteHealth ? "..." : (websiteStatusCode ?? "-")}</div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 mb-4">
                    <div className="card card-custom bg-light-info border-0 shadow-none h-100 mb-0">
                      <div className="card-body py-5">
                        <div className="text-muted text-uppercase font-size-sm font-weight-bold mb-2">Response Time</div>
                        <div className="font-size-h2 font-weight-bolder text-dark">{isFetchingWebsiteHealth ? "..." : (websiteResponseTime ? `${websiteResponseTime}ms` : "-")}</div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 mb-4">
                    <div className="card card-custom bg-light-warning border-0 shadow-none h-100 mb-0">
                      <div className="card-body py-5">
                        <div className="text-muted text-uppercase font-size-sm font-weight-bold mb-2">Last Checked</div>
                        <div className="font-size-h5 font-weight-bolder text-dark">{isFetchingWebsiteHealth ? "..." : (websiteCheckedAt ? formatDate(websiteCheckedAt) : "-")}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card card-custom gutter-b mb-0">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6 mb-4">
                        <div className="font-weight-bold text-muted mb-1">Target URL</div>
                        <div className="font-weight-bolder text-dark">{websiteTarget}</div>
                      </div>
                      <div className="col-md-6 mb-4">
                        <div className="font-weight-bold text-muted mb-1">Backend Verdict</div>
                        <span className={`label label-lg label-light-${websiteHealthColor} label-inline`}>
                          {websiteHealthLabel}
                        </span>
                      </div>
                      <div className="col-md-6 mb-4">
                        <div className="font-weight-bold text-muted mb-1">Reason</div>
                        <div>{isFetchingWebsiteHealth ? "Loading..." : websiteReason}</div>
                      </div>
                      <div className="col-md-6 mb-4">
                        <div className="font-weight-bold text-muted mb-1">Checked At</div>
                        <div>{isFetchingWebsiteHealth ? "Loading..." : (websiteCheckedAt ? formatDate(websiteCheckedAt) : "-")}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* BVN Confirmation Modal */}
              <Modal show={showConfirmBvn} onHide={() => setShowConfirmBvn(false)} centered>
                <Modal.Header closeButton>
                  <Modal.Title>Confirm Action</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                Are you sure you want to reprocess all pending BVN verifications?
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="light" onClick={() => setShowConfirmBvn(false)} disabled={isTriggeringBvn}>
                    Cancel
                  </Button>
                  <Button variant="primary" onClick={onConfirmTriggerPendingBvn} disabled={isTriggeringBvn}>
                    {isTriggeringBvn ? "Please wait..." : "Confirm"}
                  </Button>
                </Modal.Footer>
              </Modal>

              <Modal show={!!selectedCron} onHide={closeCronModal} centered size="lg">
                <Modal.Header closeButton>
                  <Modal.Title id="contained-modal-title-vcenter">
                    {selectedCron?.name || "Cron Details"}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {selectedCron && (
                    <div className="row">
                      <div className="col-md-6 mb-4">
                        <div className="font-weight-bold text-muted mb-1">Address</div>
                        <div>{selectedCron.address || "-"}</div>
                      </div>
                      <div className="col-md-6 mb-4">
                        <div className="font-weight-bold text-muted mb-1">Runtime Status</div>
                        <div>{renderCronRuntimeStatus(selectedCron.runtimeStatus)}</div>
                      </div>
                      <div className="col-md-6 mb-4">
                        <div className="font-weight-bold text-muted mb-1">Status</div>
                        <div>{formatStatus(selectedCron.status || "unknown")}</div>
                      </div>
                      <div className="col-md-6 mb-4">
                        <div className="font-weight-bold text-muted mb-1">Checked At</div>
                        <div>{selectedCron.checkedAt ? formatDate(selectedCron.checkedAt) : "-"}</div>
                      </div>
                      <div className="col-md-12 mb-4">
                        <div className="font-weight-bold text-muted mb-1">Description</div>
                        <div>{selectedCron.description || "-"}</div>
                      </div>
                      <div className="col-md-6 mb-4">
                        <div className="font-weight-bold text-muted mb-1">Schedule</div>
                        <div>{selectedCron.schedule || "-"}</div>
                      </div>
                      <div className="col-md-6 mb-4">
                        <div className="font-weight-bold text-muted mb-1">Next Schedule</div>
                        <div>{selectedCron.nextRunSchedule || "-"}</div>
                      </div>
                      <div className="col-md-6 mb-4">
                        <div className="font-weight-bold text-muted mb-1">Last Run</div>
                        <div>{selectedCron.lastRunTime ? formatDate(selectedCron.lastRunTime) : "Never"}</div>
                      </div>
                      <div className="col-md-6 mb-4">
                        <div className="font-weight-bold text-muted mb-1">Next Run</div>
                        <div>{selectedCron.nextRunTime ? formatDate(selectedCron.nextRunTime) : "-"}</div>
                      </div>
                      <div className="col-md-6 mb-4">
                        <div className="font-weight-bold text-muted mb-1">Created</div>
                        <div>{selectedCron.created ? formatDate(selectedCron.created) : "-"}</div>
                      </div>
                      <div className="col-md-6 mb-4">
                        <div className="font-weight-bold text-muted mb-1">Updated</div>
                        <div>{selectedCron.updated ? formatDate(selectedCron.updated) : "-"}</div>
                      </div>
                      <div className="col-md-6 mb-4">
                        <div className="font-weight-bold text-muted mb-1">Drift</div>
                        <div>{formatCronDrift(selectedCron)}</div>
                      </div>
                      <div className="col-md-6 mb-4">
                        <div className="font-weight-bold text-muted mb-1">Last Run Schedule</div>
                        <div>{selectedCron.lastRunSchedule || "-"}</div>
                      </div>
                    </div>
                  )}
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="light" onClick={closeCronModal}>
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Settings
